export const dataFromSmartPlanning = bool => ({
  type: 'DATA_FROM_SMART_PLANNING',
  bool
})
